import React, { Component } from 'react';
import { defaultHeaders } from './util';
import {Header} from './header.js';
import {Footer} from './footer.js';
import * as util from "./util";
import {
  ProductRating, ProductDetailsButtons, ProductMediaMultiParent,
  ProductReviews, TenderPrice, ProductDescriptionTender, CommUserInfo
, ProductTypeWithoutParantheses, ProductTypeWithLabel} from './product-details';
import { CategoryPathWithLabel } from './show-categorypath.js';
import './product-details.css';

let faqProductDetails = [
  {
    content: "Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact-us/#contactform'>hier</a>.",
    title: "Nicht fündig geworden?",
    key: 0
  }
];

export class TenderDetails extends Component {
  constructor(props) {
    super(props);
    this.getTenderDetails = this.getTenderDetails.bind(this);

    this.state = {
      id: this.props.match.params['id'],
      name: '',
      board: '',
      uuid: '',
      type: 'Ausschreibung',
      target_group: '',
      categories: '',
      description: '',
      price: '',
      aim: '',
      tags: '',
      pdf_files: ',,,,',
      image_files: ',,,,,,,,,',
      video_files: ''
    }

    if (!util.isCommercialUser() && !util.isNonCommercialUser() && this.id !== undefined) {
      util.loginGuest( () => this.getTenderDetails(this.props.match.params['id']) );
    } else {
      this.getTenderDetails(this.props.match.params['id']);
    }
  }

  componentWillReceiveProps(nextProps) {
    const newID = parseInt(nextProps.match.params['id'], 10);
    const oldID = parseInt(this.state.id, 10);
    if (oldID !== newID) {
      this.getTenderDetails(newID);
      this.setState({ id: newID });
    }
  }

  getTenderDetails(productID) {
    const self = this;
    const url = `/api/show-tender?id=${productID}`;
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.json())
      .catch(function (exception) {
        alert('Ausschreibungdetails konnten nicht geladen werden.');
        console.error('Could not fetch tender details.', exception);
      });

    promise.then(function (json) {
      localStorage.setItem('product-name', json.name);
      self.setState({
        name: (json.name ? json.name : '(kein Name)'),
        board: json.board ? json.board : '',
        uuid: json.uuid ? json.uuid : '',
        categories: (json.categories ? json.categories :'(keine Angaben)'),
        description: (json.description ? json.description : '(keine Angabe)'),
        target_group: (json.target_group ? json.target_group : '(keine Angabe)'),
        price: (json.price !== undefined ? json.price : '(keine Angabe)'),
        aim: (json.aim ? json.aim : '(keine Angabe)'),
        tags: (json.tags ? json.tags : '(keine Angabe)'),
        pdf_files: (json.pdf_files ? json.pdf_files : '(keine Angabe)'),
        image_files: (json.image_files ? json.image_files : '(keine Angabe)'),
        video_files: (json.video_files ? json.video_files : '(keine Angabe)'),
      });
      return;
    });
    return;
  }

  render() {
    return (
      <div className="Landing" id="contentId">
      <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
          <div className="productHeader1">
              {/* <ProductType name={this.state.name} productType={this.state.type} />*/}
              <ProductTypeWithoutParantheses name={this.state.name} />
            </div>
            
            <ProductDetailsButtons history={this.props.history} board={this.state.board} productID={this.state.id} price={this.state.price} productType={this.state.type} productName={this.state.name}  onNewMessage={this.props.onNewMessage} />
        
            <div className="productInfoHeader">

     
        {util.isGuestUser() && <h3>Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur für eingeloggte Nutzer sichtbar.</h3>}
        <ProductTypeWithLabel  productType={this.state.type} />
        <CommUserInfo id={this.props.match.params['id']} table={"tender"} />
        <CategoryPathWithLabel ids={this.state.categories} startID={2} />
        <ProductRating uuid={this.state.uuid} />
        {!util.isGuestUser() && <TenderPrice price={this.state.price} />}
        </div>
        <ProductTabsTender
            onNewMessage={this.props.onNewMessage}
            uuid={this.state.uuid}
            productID={this.state.id}
            aim={this.state.aim}
            description={this.state.description}
            categories={this.state.categories}
            target_group={this.state.target_group}
            tags={this.state.tags}
            pdf_files={this.state.pdf_files}
            image_files={this.state.image_files}
            video_files={this.state.video_files}/>
        <ProductDetailsButtons history={this.props.history} board={this.state.board} productID={this.state.id} price={this.state.price} productType={this.state.type} productName={this.state.name}  onNewMessage={this.props.onNewMessage} />
      </div>
      </div>
      <Footer faqs={faqProductDetails} />
      </div>
    )
  }
}

class ProductTabsTender extends Component {
  constructor(props) {
    super(props);
    this.makeActive = this.makeActive.bind(this);
    this.state = { activeTab: 0 };
  }

  makeActive(i) {
    this.setState({ activeTab: i });
  }

  render() {
    return (
      <div className="ProductTabs">
        <div className="ProductTabsButtons">
          <button className={this.state.activeTab === 0 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(0)} >Beschreibung</button>
          <button className={this.state.activeTab === 1 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(1)} >Reviews</button>
          <button className={this.state.activeTab === 2 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(2)} >Medien</button>
          <ProductDescriptionTender style={this.state.activeTab === 0 ? null : { display: 'none' }}
                                    description={this.props.description}
                                    tags={this.props.tags}
                                    target_group={this.props.target_group}
                                    aim={this.props.aim}/>
          <ProductReviews uuid={this.props.uuid} style={this.state.activeTab === 1 ? null : { display: 'none' }}
                          onNewMessage={this.props.onNewMessage} />
          <ProductMediaMultiParent style={this.state.activeTab === 2 ? null : { display: 'none' }}
                                   heading1={'Dokumentation'}
                                   uuids1={this.props.pdf_files}
                                   heading2={'Beschreibende Bilder oder Screenshots'}
                                   uuids2={this.props.image_files}
                                   heading3={'Video'}
                                   uuids3={this.props.video_files}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/show-tender.js